import GUI from 'lil-gui';

export type DebugTuning = {
  exposure: number;
  maxDpr: number;
  tensionScale: number;
  bloom: number;
  ambientOcclusion: boolean;
};

export class DebugTools {
  private gui: GUI | null = null;
  readonly enabled: boolean;

  constructor(tuning: DebugTuning, onChange: () => void) {
    this.enabled = new URLSearchParams(window.location.search).has('debug');
    if (!this.enabled) return;
    this.gui = new GUI({ title: 'Walk Home tuning' });
    this.gui.add(tuning, 'tensionScale', 0, 4, 0.05);
    this.gui.add(tuning, 'exposure', 0.4, 2.5, 0.01).onChange(onChange);
    this.gui.add(tuning, 'bloom', 0, 2, 0.01).onChange(onChange);
    this.gui.add(tuning, 'ambientOcclusion').onChange(onChange);
    this.gui.add(tuning, 'maxDpr', 1, 2, 0.25).onChange(onChange);
  }

  setHidden(hidden: boolean): void {
    if (!this.gui) return;
    if (hidden) this.gui.hide();
    else this.gui.show();
  }

  dispose(): void {
    this.gui?.destroy();
    this.gui = null;
  }
}
